import { Module } from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { IDepartmentState } from "../types";
import { StoreState } from "@/store/type";

const departmentModule: Module<IDepartmentState, StoreState> = {
  state,
  getters,
  mutations,
  actions,
};

export default departmentModule;
